export const setupConstants = {
    DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_REQUEST: "DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_REQUEST",
    DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_SUCCESS: "DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_SUCCESS",
    DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_FAILURE: "DETERMINE_SHOPIFY_PAYMENT_PROVIDERS_FAILURE",

    GET_SETUP_STATUS_REQUEST: "GET_SETUP_STATUS_REQUEST",
    GET_SETUP_STATUS_SUCCESS: "GET_SETUP_STATUS_SUCCESS",
    GET_SETUP_STATUS_FAILURE: "GET_SETUP_STATUS_FAILURE",

    ACTIVATE_SHOPIFY_BILLING_REQUEST: "ACTIVATE_SHOPIFY_BILLING_REQUEST",
    ACTIVATE_SHOPIFY_BILLING_SUCCESS: "ACTIVATE_SHOPIFY_BILLING_SUCCESS",
    ACTIVATE_SHOPIFY_BILLING_FAILURE: "ACTIVATE_SHOPIFY_BILLING_FAILURE",

    PREPARE_SHOPIFY_BILLING_FOR_CLIENT_REQUEST: "PREPARE_SHOPIFY_BILLING_FOR_CLIENT_REQUEST",
    PREPARE_SHOPIFY_BILLING_FOR_CLIENT_SUCCESS: "PREPARE_SHOPIFY_BILLING_FOR_CLIENT_SUCCESS",
    PREPARE_SHOPIFY_BILLING_FOR_CLIENT_FAILURE: "PREPARE_SHOPIFY_BILLING_FOR_CLIENT_FAILURE",

    ACTIVATE_SHOPIFY_BILLING_CHARGE_REQUEST: "ACTIVATE_SHOPIFY_BILLING_CHARGE_REQUEST",
    ACTIVATE_SHOPIFY_BILLING_CHARGE_SUCCESS: "ACTIVATE_SHOPIFY_BILLING_CHARGE_SUCCESS",
    ACTIVATE_SHOPIFY_BILLING_CHARGE_FAILURE: "ACTIVATE_SHOPIFY_BILLING_CHARGE_FAILURE",

    DELETE_APPSTORE_ACCOUNT_REQUEST: "DELETE_APPSTORE_ACCOUNT_REQUEST",
    DELETE_APPSTORE_ACCOUNT_SUCCESS: "DELETE_APPSTORE_ACCOUNT_SUCCESS",
    DELETE_APPSTORE_ACCOUNT_FAILURE: "DELETE_APPSTORE_ACCOUNT_FAILURE",
};
